export default 'Cas clients réels et documentés | Solution Éco France';
